module.exports = __webpack_public_path__ + "img/58.ced2b9a6.jpg";